import { Trans } from '@lingui/react/macro';

interface ClaimSuggestedActionsCardProps {
  suggestedActions: string[];
}

export const ClaimSuggestedActionsCard = ({
  suggestedActions,
}: ClaimSuggestedActionsCardProps) => {
  if (suggestedActions.length === 0) {
    return null;
  }

  return (
    <>
      <div className="vai-w-full vai-rounded-[6px] vai-border vai-border-zinc-800 vai-bg-[rgba(41,46,59,0.25)] vai-p-4">
        <p className="vai-mb-2 vai-text-[12px] vai-font-medium vai-uppercase vai-leading-4 vai-tracking-[0.6px] vai-text-zinc-300">
          <Trans>Suggested Actions</Trans>
        </p>
        <div className="vai-space-y-1.5">
          {suggestedActions.map((action) => (
            <div key={action} className="vai-flex vai-items-start vai-gap-1.5">
              <span className="vai-text-[12px] vai-leading-[17px] vai-text-zinc-400">
                •
              </span>
              <p className="vai-flex-1 vai-text-[14px] vai-leading-5 vai-text-zinc-400">
                {action}
              </p>
            </div>
          ))}
        </div>
      </div>
      <p className="vai--mt-1 vai-text-[12px] vai-italic vai-leading-4 vai-text-zinc-400">
        <Trans>
          Claim Strength suggestions are intended for insurance claim use only
          and are not a cleared medical device feature.
        </Trans>
      </p>
    </>
  );
};
